export default __webpack_public_path__ + "static/media/reforestacion.a739fd44.png";